import { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import Alerta from "../../components/alerta/Alerta";
import Loader from "../../components/loader/Loader";
import Sidebar from "../../components/sidebar/Sidebar";
import Topbar from "../../components/topbar/Topbar";
import style from "./AvaliacaoEditavel.module.css";
import AvaliacaoApi from "../../services/AvaliacaoApi";
import { Button, Form } from "react-bootstrap";
import GraficoRadar from "../../components/graficoRadar/GraficoRadar";
import { AiOutlineUp, AiOutlineDown } from "react-icons/ai";
import { MdSave } from "react-icons/md";
import { useIsMobile } from "../../components/useIsMobile/UseIsMobile";
import CriterioApi from "../../services/CriterioApi";
import { Navigate } from "react-big-calendar";
import { useNavigate } from "react-router-dom";

function AvaliacaoEditavel() {
  const location = useLocation();
  const [avaliacaoId, setAvaliacaoId] = useState(() => {
    return location.state || localStorage.getItem("avaliacaoId") || null;
  });


  const [alunoId, setAlunoId] = useState(() => {
    return location.state || localStorage.getItem("alunoId") || null;
  });
 

  const navigate = useNavigate();


  const [mostrarAlerta, setMostrarAlerta] = useState(false);
  const [mensagemAlerta, setMensagemAlerta] = useState("");
  const [tipoAlerta, setTipoAlerta] = useState("");
  const [loading, setLoading] = useState(false);
  const [avaliacaoCompleta, setAvaliacaoCompleta] = useState(null);
  const [avaliacaoEnum, setAvaliacaoEnum] = useState([]);
  const [visibilidadeDescricao, setVisibilidadeDescricao] = useState({});
  const [criteriosComPontos, setCriteriosComPontos] = useState([]);
  const [valoresSelecionados, setValoresSelecionados] = useState({});
  const [tipoAvaliacao, setTipoAvaliacao] = useState([]);
  const [tipoAvaliacaoSelecionada, setTipoAvaliacaoSelecionada] = useState({});
  const isMobile = useIsMobile();
  const [menuHamburguerAberto, setMenuHamburguerAberto] = useState(!isMobile);

  useEffect(() => setMenuHamburguerAberto(!isMobile), [isMobile]);




  useEffect(() => {
    async function carregarDados() {
      setLoading(true);
      try {


        // Carregar primeiro os tipos, enums e critérios
        const [listaEnum, tipos, criterios] = await Promise.all([
          AvaliacaoApi.ListarEnumAvaliacao(),
          AvaliacaoApi.ListarEnumTipoAvaliacao(),
          CriterioApi.ListarCriteriosTodosAsync()
        ]);

        setAvaliacaoEnum(listaEnum);
        setTipoAvaliacao(tipos);
        setCriteriosComPontos(criterios);

        // Depois buscar a avaliação (porque depende de tipos já carregados)
        const dados = await AvaliacaoApi.ObterAvaliacaoCompleta(avaliacaoId);
        setAvaliacaoCompleta(dados);

        // Agora é seguro fazer isso
        const tipoSelecionado = tipos.find(t => t.id === dados.tipoAvaliacaoEnum);
        if (tipoSelecionado) setTipoAvaliacaoSelecionada(tipoSelecionado);

        const valoresIniciais = {};
        dados.criterios.forEach((c) => {
          const ponto = c.pontosCriterios[0];
          if (ponto) valoresIniciais[c.criterioID] = ponto.nota;
        });
        setValoresSelecionados(valoresIniciais);
      } catch (error) {
        console.error(error);
        setMensagemAlerta("Erro ao carregar a avaliação");
        setTipoAlerta("danger");
        setMostrarAlerta(true);
      } finally {
        setLoading(false);
      }
    }

    if (avaliacaoId) {
      localStorage.setItem("avaliacaoId", avaliacaoId);
      carregarDados();
    }

    return () => {
      localStorage.removeItem("avaliacaoId");
    };
  }, [avaliacaoId]);

  const AlternarVisibilidade = (criterioId) => {
    setVisibilidadeDescricao(prev => ({
      ...prev,
      [criterioId]: !prev[criterioId]
    }));
  };

  const selecionarNota = (criterioId, novaNota) => {
    setValoresSelecionados(prev => ({
      ...prev,
      [criterioId]: novaNota
    }));
  };

  const atualizarAvaliacao = async () => {
    setMostrarAlerta(true);
    try {
      const pontosSelecionados = criteriosComPontos.map((criterio) => {
        const notaSelecionada = valoresSelecionados[criterio.id];
        const ponto = criterio.pontosCriterios.find(p => p.nota === notaSelecionada);
        return ponto?.id;
      }).filter(Boolean); // remove nulls

      const notas = criteriosComPontos.map((criterio) => {
        return valoresSelecionados[criterio.id] || 0;
      });

      const media =
        notas.length > 0
          ? notas.reduce((soma, n) => soma + n, 0) / notas.length
          : 0;

      const payload = {
        avaliacaoId,
        media: Number(media.toFixed(2)),
        pontosCriteriosID: pontosSelecionados,
        pontosPositivos: avaliacaoCompleta.pontosPositivos,
        pontosEvolucao: avaliacaoCompleta.pontosEvolucao,
        direcionadores: avaliacaoCompleta.direcionadores,
        tipoAvaliacaoEnum: tipoAvaliacaoSelecionada.id
      };
      await AvaliacaoApi.AtualizarAvaliacaoAsync(payload);

      setTipoAlerta("success");
      setMensagemAlerta("Avaliação atualizada com sucesso!");
      setMostrarAlerta(true)
      setTimeout(() => setMostrarAlerta(false), 2000);
      // setTimeout(() => {
      //   navigate("/avaliacoes/aluno", { state: alunoId });

      // }, 1500);
    } catch (error) {
      setMostrarAlerta(true);

    } finally {
      setLoading(false)

    }
  };


  useEffect(() => {

    if (alunoId) {
      localStorage.setItem("alunoId", alunoId);
    }
   
  }, [alunoId]);

  useEffect(() => {
    return () => {
      localStorage.removeItem("alunoId");
    };
  }, []);

  return (
    <Sidebar menuHamburguerAberto={menuHamburguerAberto} setMenuHamburguerAberto={setMenuHamburguerAberto}>
      <Topbar menuHamburguerAberto={menuHamburguerAberto} setMenuHamburguerAberto={setMenuHamburguerAberto}>
        <Alerta tipo={tipoAlerta} mensagem={mensagemAlerta} visivel={mostrarAlerta} aoFechar={() => setMostrarAlerta(false)} />
        {loading && <Loader />}
        <Alerta
          tipo={tipoAlerta}
          mensagem={mensagemAlerta}
          visivel={mostrarAlerta}
          aoFechar={() => setMostrarAlerta(false)}
        />
        <div className={style.pagina_conteudo}>
          <h4>Editando avaliação de {avaliacaoCompleta ? new Date(avaliacaoCompleta.dataRealizada).toLocaleDateString("pt-BR") : ""}</h4>


          <Form onSubmit={(e) => { e.preventDefault(); atualizarAvaliacao(); }} className={style.criterios_graficos}>
            <div className={style.container_criterios}>
              {criteriosComPontos.map((criterio) => (
                <div key={criterio.id} className={style.container_criterio}>
                  <div className={style.input_select_container}>
                    {valoresSelecionados[criterio.id] && (
                      <button type="button" onClick={() => AlternarVisibilidade(criterio.id)} id={style.botao_toggle}>
                        {visibilidadeDescricao[criterio.id] ? <AiOutlineUp /> : <AiOutlineDown />}
                      </button>
                    )}

                    <Form.Label className={style.nomelabel}>{criterio.nome}</Form.Label>
                    <Form.Group controlId={`dropdown-${criterio.id}`}>
                      <Form.Select
                        className={style.select}
                        required
                        value={valoresSelecionados[criterio.id] || ""}
                        onChange={(e) => selecionarNota(criterio.id, Number(e.target.value))}
                      >
                        <option value="" disabled>Selecione uma nota</option>
                        {criterio.pontosCriterios.map((ponto) => (
                          <option key={ponto.id} value={ponto.nota}>
                            {avaliacaoEnum.find(x => x.id === ponto.nota)?.nome || ponto.nota}
                          </option>
                        ))}
                      </Form.Select>
                    </Form.Group>
                  </div>

                  {visibilidadeDescricao[criterio.id] && (
                    <p className={style.descricao}>
                      {criterio.pontosCriterios.find(p => p.nota === valoresSelecionados[criterio.id])?.descricao}
                    </p>
                  )}
                </div>
              ))}

              <Form.Group>
                <Form.Label>Pontos Positivos</Form.Label>
                <Form.Control as="textarea" value={avaliacaoCompleta?.pontosPositivos || ""} onChange={(e) => setAvaliacaoCompleta(prev => ({ ...prev, pontosPositivos: e.target.value }))} />
              </Form.Group>

              <Form.Group>
                <Form.Label>Pontos de Evolução</Form.Label>
                <Form.Control as="textarea" value={avaliacaoCompleta?.pontosEvolucao || ""} onChange={(e) => setAvaliacaoCompleta(prev => ({ ...prev, pontosEvolucao: e.target.value }))} />
              </Form.Group>

              <Form.Group>
                <Form.Label>Direcionadores</Form.Label>
                <Form.Control as="textarea" value={avaliacaoCompleta?.direcionadores || ""} onChange={(e) => setAvaliacaoCompleta(prev => ({ ...prev, direcionadores: e.target.value }))} />
              </Form.Group>
            </div>

            <div className={style.grafico_radar}>
              <GraficoRadar
                labels={criteriosComPontos.map(c => c.nome)}
                data={criteriosComPontos.map(c => valoresSelecionados[c.id] || 0)}
              />
            </div>
          </Form>

          <Form.Group className={style.tipo}>
            <Form.Select required className={style.inputSelect} value={tipoAvaliacaoSelecionada?.id || ""} onChange={(e) => {
              const id = Number(e.target.value);
              const tipo = tipoAvaliacao.find(t => t.id === id);
              if (tipo) setTipoAvaliacaoSelecionada(tipo);
            }}>

              {tipoAvaliacao.map((tipo) => (
                <option key={tipo.id} value={tipo.id}>{tipo.nome}</option>
              ))}
            </Form.Select>
          </Form.Group>

          <div id={style.botao_salvar}>
            <Button
              onClick={atualizarAvaliacao}>

              <MdSave /> Salvar Avaliação
            </Button>
          </div>
        </div>
      </Topbar>
    </Sidebar>
  );
}

export default AvaliacaoEditavel;
